export function RotatingLoader() {
  return (
    <span className="relative z-10 m-auto h-[0.25rem] w-[0.25rem] animate-rotating-loader rounded-[50%] indent-[-9999em] text-[3px] [transform:translateZ(0)]" />
  )
}
